import { render, staticRenderFns } from "./PlaylistResults.vue?vue&type=template&id=63a49674&"
import script from "./PlaylistResults.vue?vue&type=script&lang=js&"
export * from "./PlaylistResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports